<template>
  <lazy-component>
    <div class="integrations">
      <div style="height:100%" :style="largeScreenContainer">
        <v-container>
          <v-row>
            <v-col>
              <p
                v-if="$vuetify.breakpoint.smAndDown"
                class="integrations-title"
              >
                Lorem ipsum dolor sit
              </p>
              <p v-else class="integrations-title">
                Lorem ipsum dolor sit amet consetetur
              </p>
              <p class="integrations-desc">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore
              </p>
              <div class="integrations-img">
                <img
                  v-if="$vuetify.breakpoint.smAndDown"
                  src="@/assets/img/integrations-mobile.png"
                  alt=""
                />
                <img v-else src="@/assets/img/integrations.png" alt="" />
              </div>
              <v-btn class="hero-cta integrations-btn" outlined elevation="0">
                Explore Triange Integrations
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </lazy-component>
</template>

<script>
export default {};
</script>

<style lang="scss">
.integrations {
  text-align: center;
  padding-top: 45px;
  padding-bottom: 128px;

  &-title {
    font-size: 40px;
    margin-bottom: 40px;
    font-weight: bold;
  }
  &-desc {
    color: #575452;
    font-size: 18px;
  }
  &-img {
    img {
      height: 100%;
      width: 100%;
    }
    margin: 80px;
  }
  &-btn {
    height: 48px !important;
    border: 2px solid #d1c5f9;

    span {
      color: $primary-color;
      font-weight: 500;
      font-size: 16px !important;
    }
  }
}

@include smMax {
  .integrations {
    padding-top: 10px;
    padding-bottom: 30px;
    &-img {
      margin: 40px;
    }
    &-title {
      font-size: 30px;
      margin-bottom: 62px !important;
    }
    &-desc {
      font-size: 16px;
    }
    &-btn {
      border-radius: 999px !important;
      max-width: 286px;
      border: 1px solid #d1c5f9 !important;

      span {
        text-transform: none;
      }
    }
  }
}
</style>
